export const INITIAL = {
	MODAL: {
		content: '',
		data: {}
	},
	VALUES: {
		id: '',
	},
	LIST: {
		0: {
			id: 0,
			name: 'Nome',
			race: 'Raça',
			caste: 'Classe',
			tendency: 'Tendência',
			description: 'Descrição do personagem',
			life: 0,
			coins: 0,
			actions: 0,
			strength: 0,
			dexterity: 0,
			constitution: 0,
			intelligence: 0,
			wisdom: 0,
			charisma: 0,
			capacity: {
				life: 0,
				physical: 0,
				mental: 0,
			},
			modified: {
				strength: 0,
				dexterity: 0,
				constitution: 0,
				intelligence: 0,
				wisdom: 0,
				charisma: 0,
			}
		}
	}
}